'use client'
import Marquee from "react-fast-marquee";
import { useEffect, useState } from "react";
import { allImages } from "./images";

import styles from './corporate.module.scss'


const CorporateForPC = ({ data }) => {
  return <Marquee
    pauseOnHover
    style={{ width: '100vw', position: 'relative', left: 0 }}
  >
    {[...data, ...data].map((v, i) => {
      return <div key={i}>
        <img src={v} height={100} />
      </div>
    })}
  </Marquee>
}

const CorporateForMobile = ({ data }) => {
  return <div className={styles.corporateForMobile}>
    {data.map((v, i) => {
      return <div className={styles.item} key={i}>
        <img src={v} />
      </div>
    })}
  </div>
}

export const Corporater = ({ dictionary }) => {
  const [winWidth, setWinWith] = useState(1000)
  const lang = dictionary
  const { remotePage, } = lang || {}

  useEffect(() => {
    let resizeHandle = () => {
      setWinWith(window.innerWidth)
    }

    window.addEventListener('resize', resizeHandle);
    return () => {
      window.removeEventListener('resize', resizeHandle);
    }
  }, [])
  useEffect(() => {
    setWinWith(window?.innerWidth)
  }, [])

  return <div className={styles.corporateRoot}>
    <div className={styles.dividerRoot}>
      <div className={styles.divider} />
      <span className={styles.dividerText} >
        {remotePage?.topCompany}
      </span>
    </div>
    <div style={{ marginTop: 64, position: 'relative', }}>
      {
        winWidth > 810 ?
          <CorporateForPC data={allImages} />
          : <CorporateForMobile data={allImages} />
      }
      {
        winWidth > 810 ?
          <>
            <div className={styles.opacityCover} />
            <div className={styles.opacityCover} />
          </>
          : null
      }
    </div>
  </div >
}